export default `
query QueryPropertyEventsByInstanceIdCreatedAtIndex($instanceId: String!, $first: Int, $after: String) {
  queryPropertyEventsByInstanceIdCreatedAtIndex(instanceId: $instanceId, first: $first, after: $after) {
    items {
      icon
      text
      createdAt
      senderName
      eventId
      senderId
      propertyId
      instanceId
    }
    nextToken
  }
}
`;